import { Component, OnInit } from '@angular/core';
import { AuthService } from '../app/services/auth.service';

import { Spinkit } from 'ng-http-loader';

import { trigger, animate, transition, style, query, animateChild } from '@angular/animations';
import { SnotifyService } from 'ng-snotify';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('fadeAnimation', [
      transition('* => *', [
        query(':enter', [
          style({
            opacity: 0,
            transform: 'translateY(15%)'
          })],
          { optional: true }
        ),
        query(
          ':leave',
          // here we apply a style and use the animate function to apply the style over 0.3 seconds
          [style({ opacity: 1 }), animate('0.1s', style({ opacity: 0 }))],
          { optional: true }
        ),
        query(
          ':enter',
          [style({ opacity: 0 }), animate('0.1s', style({ opacity: 1, transform: 'translateY(0%)' }))],
          { optional: true }
        )
      ])
    ])
  ]
})
export class AppComponent {
  public spinkit = Spinkit;

  title = 'app';

  currentUser;

  constructor(private auth: AuthService, private snotifyService: SnotifyService) {
    this.auth.currentUser.subscribe(data => {
      this.currentUser = data;
    });

    this.auth.getUser();
  }

  ngOnInit() {

  }
}

//animations: [
//  trigger('pageAnimation', [
//    transition('* <=> *', [
//      // Initial state of new route
//      query(':enter',
//        style({
//          position: 'fixed',
//          width: '100%',
//          height: '100%',
//          transform: 'translateY(-100%)',
//          opacity: 1
//        }),
//        { optional: true }),

//      // move page off screen right on leave
//      query(':leave',
//        animate('150ms',
//          style({
//            position: 'fixed',
//            width: '100%',
//            height: '100%',
//            transform: 'translateY(100%)',
//            opacity: 0,
//          })
//        ),
//        { optional: true }),

//      // move page in screen from left to right
//      query(':enter',
//        animate('150ms',
//          style({
//            opacity: 1,
//            transform: 'translateY(0%)',
//          })
//        ),
//        { optional: true }),
//    ])
//  ])

